import React from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { createBrowserHistory } from "history";
import { alertActions } from "../../actions";
import { sessionActions } from "../../state/ducks/session";
import { mmbActions } from "../../state/ducks/mmb";
import { UserType } from "../../constants/settings";
import { webkitHelper } from "../../helpers";
import { ls } from "../../locale";

const redirectInstructions = "Due to the issue above, your booking was not completed successfully. Please try making the booking again."

function Alert(props) {

  const errors = props.errors;
  const insufficientInventory = Array.isArray(errors) && errors.some(x => x.errorCode === 558 || x.errorCode === "558");

  const handleClose = () => {

    
    props.clear();

    // const underMaintenance = Array.isArray(errors) && errors.some(x => x.errorCode === 503 || x.errorCode === "503" || x.errorCode === 502 || x.errorCode === "502");
    // if (underMaintenance) {
    //   window.location.href = "/maintain.html";
    //   return;
    // }

    const userData = props.getUserData();
    const bookingMode = props.getBookingMode()?.mode;

    const sessionExpired = Array.isArray(errors) && errors.some(x => x.errorCode === 403 || x.errorCode === "403");
    if (sessionExpired) {
      if (webkitHelper.sendSessionExpired()) return;

      // clear session 
      props.setSessionToken(null);
      redirectSessionExpired(userData, bookingMode);
      return;
    }

    // check insufficient inventory error (error code 558) and redirect to search page if exist
    if (insufficientInventory) {
      redirectSearch(userData, bookingMode, props.resetBooking);
    }
  }

  const rButton = ls.t('Button');
  const rTitle = ls.t('MessageBox.Title');

  const close = rButton.Close || 'Close';
  const error = rTitle.Error || 'Error';


  return (
    <Modal className={ls.t("rootClass")} show={props.show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>{error}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"salam-air-popup " + ls.t("rootClass")}>
          <h3>{props.getUserDataessage}</h3>
          { Array.isArray(props.errors) && props.errors.map((error, index) => (
              <p key={index}>[{error.errorCode}] {error.message}</p>
            ))
          }
          {insufficientInventory && <p>{redirectInstructions}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => handleClose()}>{close}</Button>
      </Modal.Footer>
    </Modal>
  )
}

function redirectSessionExpired(userData, bookingMode) {
  const lng = ls.lang;

  let dest = 'search';
  if (userData && userData.userType === UserType.agent) {
    dest = 'agent';
  }
  else if (userData && userData.userType === UserType.member) {
    dest = 'member';
  }
  else {
    if (bookingMode === 'WCI')
      dest = 'wci';
    else if (bookingMode === 'MMB')
      dest = 'mmb';
  }
  window.location.href = `/${lng}/${dest}`;
}

function redirectSearch(userData, bookingMode, resetBooking) {
  const history = createBrowserHistory({ forceRefresh: true });
  const lng = ls.lang;

  let dest = `/${lng}`;
  if (userData && userData.userType === UserType.agent) {
    dest += `/agent`;
  }

  if(bookingMode === 'MMB') {
    // we need to reset booking before redirecting to summary page, otherwise the user will be stuck in a loop of error -> summary -> error
    dest += '/mmb/summary';
    if(typeof resetBooking !== 'function') {
      history.push(dest);
      return;
    }

    return resetBooking().then(() => {
      history.push(dest);
    }).catch(() => {
      history.push(dest);
    })
  }

  if(bookingMode === 'WCI') {
    dest += '/wci/flight';
    history.push(dest);
    return;
  }

  dest += '/search';
  history.push(dest);
}

function mapStateToProps(state) {
  return {
    ...state.redux.alert
  }
}

const mapDispatchToProps = {
  ...alertActions,
  getBookingMode: sessionActions.getBookingMode,
  setSessionToken: sessionActions.setSessionToken,
  getUserData: sessionActions.getUserData,
  resetBooking: mmbActions.resetBooking,
}

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
